var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("pageHeader", [_c("PageHeader")]),
      _c(
        "div",
        { style: _vm.contentCss },
        [_vm._t("default", [_c("RoutView")])],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }